<template>
  <div class="zone-details">
    <div class="details-top" :style="`background-image: url(${imgBgUrl});`">
      <form action="/" class="logo-container">
        <img src="../../assets/images/zone/img42.png" class="return-list"  @click="handleGo('zonelist')" alt="">
        <van-search v-model="searchContent" :disabled="`${active}` !== '1'" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
      <!-- <div class="top-tag" @click="handleGo('zonelist')">
        <span class="top-tag-txt">返回</span>
        <img src="@/assets/images/zone/img40.png" class="icon-return" alt="">
      </div> -->
      <div class="detail-con">
        <div class="con-top">
          <img src="../../assets/images/zone/img27.png" class="icon" alt="">
          <div class="txt1">{{ zonesDetails.hospitalName }}</div>
          <div class="return-tag" @click="handleFeedback">
            反馈
            <img src="../../assets/images/zone/img11.png" class="icon-tag" alt="" />
          </div>
        </div>
        <div class="con-div">
          <div class="div-txt1">{{ zonesDetails.subjectName }}</div>
          <div class="div-cons2">
            <div class="con-num">{{ zonesDetails.areaMemberNum }}</div>
            <div class="con-txt">成员</div>
          </div>
          <div class="div-cons2">
            <div class="con-num">
              {{ zonesDetails.postsNum > 0 ? zonesDetails.postsNum : 0 }}
            </div>
            <div class="con-txt">发帖量</div>
          </div>
        </div>
      </div>
      <div class="sec-flex">
        <div :class="['flex-txt', active === item.code ? 'cur' : '']" v-for="item in tabList" :key="item.code"
          @click="handleCheck(item)" v-track="{ functionName: `专区-${item.name}` }">
          <span class="txt">{{ item.name }}</span>
          <img v-show="item.code === active" src="../../assets/images/zone/img2.png" class="icon1" alt="" />
        </div>
      </div>
    </div>
    <zoneList ref="zone" :roles="roles" :areaId="areaId" v-if="active === 1"></zoneList>
    <plan :areaId="areaId" v-if="active === 2" />
    <StudentList :areaId="areaId" v-if="active === 3" />
    <StudyContent :roles="roles" :areaId="areaId" v-if="active === 4" />
    <LiveList :roles="roles" :areaId="areaId" v-if="active === 5" />
    <Work :areaId="areaId" :roles="roles" v-if="active === 6" />
    <div class="fixed-btn">
      <img src="../../assets/images/zone/img8.png" @click="showDialog = true" class="img-btn" alt="" />
    </div>
    <div class="fixed-dialog" v-if="showDialog">
      <div class="dialog-bg" @click="showDialog = false"></div>
      <div class="dialog-con">
        <div class="con-top">
          <img :src="userInfo.headPicUrl" class="top-cover" alt="" />
          <div class="top-txt">{{ userInfo.nickName }}</div>
          <div class="top-close" @click="showDialog = false">取消</div>
        </div>
        <div class="content-div">
          <div class="div-block" @click="handleGo('addpost')">
            <img src="../../assets/images/zone/img12.png" class="div-icon" alt="" />
            <div class="div-txt">发帖</div>
          </div>
          <!--  v-if="`${roles.tutorSign}` === '1' || `${roles.peSign}` === '1'" -->
          <div class="div-block" v-if="`${roles.tutorSign}` === '1' || `${roles.peSign}` === '1'" @click="handleGo('vote')">
            <img src="../../assets/images/zone/img13.png" class="div-icon" alt="" />
            <div class="div-txt">投票</div>
          </div>
          <div class="div-block" v-if="`${roles.peSign}` === '1'" @click="handleGo('livepreview')">
            <img src="../../assets/images/zone/img14.png" class="div-icon" alt="" />
            <div class="div-txt">直播预告</div>
          </div>
          <div class="div-block" @click="handleGo('addwork')" v-if="`${roles.tutorSign}` === '1' || `${roles.peSign}` === '1'">
            <!-- v-if="`${roles.tutorSign}` === '1' || `${roles.peSign}` === '1'" -->
            <img src="../../assets/images/zone/img15.png" class="div-icon" alt="" />
            <div class="div-txt">待办任务</div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="pop_box">
        <div class="title">反馈</div>
        <van-field v-model="message" rows="4" autosize type="textarea" maxlength="200" placeholder="请输入您的反馈"
          show-word-limit />
        <div class="btn_group">
          <div class="btn cancel" @click="handleCancel">取消</div>
          <div class="btn ok" @click="handleOk">确定</div>
        </div>
      </div>
    </van-popup>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>
<script>
import { getZones, zoneUserVisit, zoneDetailsImg } from '@/api/zone'
import { feebBack } from '@/api/student'
import { tabList, rolesClick } from './data'
import StudentList from './compontents/studentList.vue'
import StudyContent from './compontents/studyContent.vue'
import LiveList from './compontents/liveList.vue'
import zoneList from './compontents/zoneList.vue'
import Work from './compontents/work.vue'
import plan from './compontents/plan.vue'
import { Toast } from 'vant'
import { getShareInfo } from '@/utils/wxShare'
// import {modifyURLParam} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import {handleTraceSearchLog} from '../../utils/trace'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
const UserProfile = {
  components: {
    zoneList,
    StudentList,
    StudyContent,
    LiveList,
    Work,
    plan,
    CustomDialog
  },
  data () {
    return {
      searchContent: '',
      areaId: '',
      showDialog: false,
      zonesDetails: {},
      roles: {},
      active: 1,
      tabList,
      show: false,
      message: '',
      imgBgUrl: '',
      areaUnavailable: false,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '该专区已下架',
        showCloseIcon: false,
        cancel: () => {
          this.handleDialogClose()
        },
        confirm: () => {
          this.handleDialogClose()
        },
        close: () => {
          this.handleDialogClose()
        }
      }
    }
  },

  // userInfo.memberType 0医生1员工
  //   不同的角色该页面展示的内容范围会有不同：
  //   点击【+】，显示多种可发布的内容
  // hcp术者：发帖
  // 管理员：发帖、投票、直播预告、待办任务
  // 导师：发帖、投票、待办任务
  // 其他强生员工（非该PE管理员角色）：不显示+号
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    localStorage.removeItem('changeAboutCon')
    localStorage.removeItem('addWorkCon')
    this.areaId = this.$route.query.areaId
    if (localStorage.getItem('changeTabActive')) {
      this.active = Number(localStorage.getItem('changeTabActive'))
    }
    // roleDetails({
    //   areaId: this.$route.query.areaId,
    //   userId: this.userInfo.id
    // }).then(res => {
    //   this.roles = res.data
    //   // if (`${this.userInfo.memberType}` === '0' && `${this.roles.studentSign}` === '0') {
    //   //   this.$router.push({path: '/RTCZone/sign', query: { areaId: this.areaId }})
    //   // }
    //   localStorage.setItem('zoneRoles', JSON.stringify(this.roles))
    // })
    this.roles = JSON.parse(sessionStorage.getItem('roleResult'))

    getZones({
      areaId: this.areaId
    }).then(res => {
      this.zonesDetails = res.data || {}
      const areaStatus = Number(this.zonesDetails.areaStatus)
      if (areaStatus !== 1) {
        this.areaUnavailable = true
        this.cDialog.visible = true
        return
      }
      window.sessionStorage.setItem('mainId', this.areaId)
      window.sessionStorage.setItem('serviceId', this.areaId)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
      window.sessionStorage.setItem('entrance', entrance)
      window.sessionStorage.setItem('traceTitle', '专区详情-' + this.zonesDetails.subjectName)
      // let desc = '更智慧、更全面、更懂你。'
      let roleResult = JSON.parse(sessionStorage.getItem('roleResult'))
      let desc = roleResult.hospitalName ? `NTC专区：${roleResult.hospitalName}` : ''
      // let desc = roleResult.hospitalName ? `RTC专区：${roleResult.hospitalName}` : ''
      getShareInfo({
        title: this.zonesDetails.subjectName,
        titleTimeLine: this.zonesDetails.subjectName,
        desc: desc,
        link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '30'),
        linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '31'),
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
    })
    zoneDetailsImg({areaId: this.$route.query.areaId}).then(res => {
      this.imgBgUrl = res.data && res.data.length > 0 ? res.data[0].url : ''
    })
    // 存储当前的ntc专区，在首页点击培训中心会判断
    zoneUserVisit({
      areaId: this.$route.query.areaId,
      userId: this.userInfo.id,
      type: 1
    })
  },
  methods: {
    onCourseSearchEnter () {
      if (this.areaUnavailable) return
      if (`${this.active}` !== '1') return
      this.$refs.zone.searchContent = this.searchContent
      this.$refs.zone.postState = {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: true,
        finishText: '没有更多了',
      }
      this.$refs.zone.postListArr = []
      this.$refs.zone.handleGetPostList()
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 7,
        'entrance': 53,
      })
    },
    clearSearchValue () { },
    handleGo (type) {
      if (this.areaUnavailable && type !== 'zonelist') return
      let path = ''
      let query = {}
      switch (type) {
        case 'addpost':
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/addPost?areaId=${this.areaId}`
          break
        case 'zonelist':
          path = `/zoneList?tab=ntc`
          break
        case 'livepreview':
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/livePreview?areaId=${this.areaId}`
          break
        case 'addwork':
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/addWork?areaId=${this.areaId}`
          break
        case 'vote':
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/addVote?areaId=${this.areaId}`
          break

        default:
          break
      }
      this.$router.push({
        path,
        query
      })
    },
    handleCheck (item) {
      if (this.areaUnavailable) return
      this.active = item.code
      if (`${this.active}` !== '1') {
        this.searchContent = ''
      }
      localStorage.setItem('changeTabActive', this.active)
    },
    handleFeedback () {
      if (this.areaUnavailable) return
      if (rolesClick(this.roles, this.userInfo)) return
      this.show = true
    },
    handleCancel () {
      this.message = ''
      this.show = false
    },
    handleOk () {
      if (this.areaUnavailable) return
      const params = {
        areaId: this.areaId,
        leaveUserId: this.userInfo.id,
        content: this.message
      }
      feebBack(params).then(res => {
        if (res.code === 0) {
          Toast('反馈成功')
          this.message = ''
          this.show = false
        }
      })
    },
    handleDialogClose () {
      this.cDialog.visible = false
      this.handleGo('zonelist')
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.zone-details {
  padding-top: 240px;
  box-sizing: border-box;
  background: #F9F8F7;

  .details-top {
    width: 100%;
    height: 230px;
    padding-bottom: 10px;
    background-color: #F9F8F7;
    background-image: linear-gradient(180.00deg, rgb(219, 215, 212),rgba(255, 255, 255, 0) 50.701%);
    background-repeat: no-repeat;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .logo-container {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      .return-list {
        width: 118px;
        display: block;
      }
      /deep/ .van-search {
        width: 240px;
        box-sizing: border-box;
        height: 38px;
        padding: 0;
        background: transparent;
        .van-search__content {
          height: 38px;
          box-sizing: border-box;
          border: 1px solid rgba(255, 255, 255, 0.8);
          border-radius: 33px;
          background: rgba(255, 255, 255, 0.8);
          .van-field__control {
            color: rgb(163, 153, 146);
            &::placeholder {
              color: rgb(163, 153, 146);
            }
          }
        }
      }
    }

    .top-tag {
      position: absolute;
      right: 0;
      top: 50px;
      width: 20px;
      height: 61px;
      background-image: url("../../assets/images/zone/img9.png");
      background-repeat: no-repeat;
      background-size: contain;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .top-tag-txt {
        font-size: 11px;
        font-weight: 500;
        line-height: 12px;
        color: #fff;
        text-align: center;
      }
      .icon-return {
        width: 11px;
        display: block;
      }
    }

    .detail-con {
      width: 350px;
      height: 86px;
      margin-left: 50%;
      transform: translateX(-50%);
      background-color: #EB1700;
      background-image: url("../../assets/images/zone/img10.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-top: 58px;
      position: relative;
      border-radius: 14px;

      .con-top {
        display: flex;
        align-items: center;
        height: 32px;
        padding-left: 12px;
        box-sizing: border-box;

        .icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
          display: block;
        }

        .txt1 {
          font-size: 14px;
          color: #81766F;
          font-weight: 500;
        }

        .return-tag {
          display: flex;
          align-items: center;
          position: absolute;
          width: 65px;
          top: 2px;
          right: 0px;
          height: 20px;
          font-size: 14px;
          color: #ffffff;
          justify-content: center;

          .icon-tag {
            width: 10px;
            height: 10px;
            display: block;
            margin-left: 2px;
          }
        }
      }

      .con-div {
        display: flex;
        align-items: center;

        .div-txt1 {
          font-size: 18px;
          color: #202020;
          font-weight: bold;
          flex: 1;
          padding-left: 12px;
          box-sizing: border-box;
        }

        .div-cons2 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-right: 14px;
          text-align: center;

          .con-num {
            font-size: 16px;
            color: #81766F;
            font-weight: 600;
            line-height: 20px;
          }

          .con-txt {
            color: #81766F;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }

    .sec-flex {
      display: flex;
      padding: 0 16px;
      box-sizing: border-box;
      height: 42px;
      align-items: center;
      margin-top: 10px;

      .flex-txt {
        position: relative;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        color: #656e7f;
        font-weight: 500;
        margin-right: 18px;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        &.cur {
          font-weight: 600;
          color: #EB1700;
        }

        .txt {
          white-space: nowrap;
        }

        .icon1 {
          position: absolute;
          width: 23px;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}

.img-btn {
  position: fixed;
  width: 50px;
  height: 50px;
  right: 6px;
  bottom: 80px;
  z-index: 99;
}

.fixed-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .dialog-bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-con {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 205px;
    background-color: #f2f7fa;

    .con-top {
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 58px;

      .top-cover {
        width: 32px;
        height: 32px;
        margin-right: 5px;
        border-radius: 50%;
        display: block;
      }

      .top-txt {
        flex: 1;
        font-size: 14px;
        color: #000000;
      }

      .top-close {
        font-size: 14px;
        color: #000000;
      }
    }

    .content-div {
      display: flex;
      padding: 0 10px;
      box-sizing: border-box;

      .div-block {
        margin-right: 6px;
        background-color: #fff;
        border-radius: 17px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 84px;
        height: 80px;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        .div-icon {
          width: 26px;
          height: 26px;
          margin-bottom: 2px;
        }

        .div-txt {
          line-height: 20px;
          font-size: 12px;
          color: #495266;
          text-align: center;
        }
      }
    }
  }
}

.van-popup--center {
  border-radius: 8px;
}

.pop_box {
  width: 320px;
  height: 260px;
  border-radius: 8px;
  background: #fff;
  padding: 16px 15px;
  box-sizing: border-box;

  .title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 17px;
    color: #000000;
    line-height: 20px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .van-cell {
    background: #F9F8F7;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  /deep/ .van-field__control::-webkit-input-placeholder {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.4);
  }

  .btn_group {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .btn {
      width: 130px;
      height: 42px;
      border-radius: 22px;
      line-height: 42px;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      margin-top: 10px;
    }

    .ok {
      background: #EB1700;
      color: #fff;
    }

    .cancel {
      background: #F1EFED;
      color: #81766F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/zoneDetails.vue